import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';
import { IntervaloAbsoluto, Momento } from '../models/enum';
import { IntervaloDeTempo } from '../models/intervalo-de-tempo';

@Injectable({
  providedIn: 'root'
})
export class IntervaloDeTempoService {

  constructor(private http: HttpClient) { }

  consultarIntervaloDeTempoAbsoluto(modelo: IntervaloAbsoluto) {

    return this.http.get<IntervaloDeTempo>(globals.apiUrl + '/api/v2/utils/intervaloDeTempo/absoluto/' + modelo);
  }

  consultarIntervaloDeTempoRelativo(momento: Momento, intervalo: string = null) {
    //1.00:00:00 = D.HH.mm.ss

    let parametros = new HttpParams();

    if (intervalo) {
      parametros = parametros.set('intervalo', intervalo);
    }

    return this.http.get<IntervaloDeTempo>(globals.apiUrl + '/api/v2/utils/intervaloDeTempo/relativo/' + momento,
      {
        params: parametros
      }
    );
  }
}
